import {initializeApp} from 'firebase/app';
import {getDatabase} from "firebase/database";
import {environment} from "../../../environments/environment";

export const firebaseDb = getDatabase(initializeApp(environment.getFirebaseConfig()));
